import React from "react";
import { SectionContainerBase } from "@reusejs/react";

export default function TeamsComponent() {
  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "py-0 pb-20 bg-gray-50",
        innerContainerStyles: "max-w-7xl mx-auto",
      }}
    >
      <div className="mx-4 pt-8 px-4 sm:px-6 lg:pt-8 lg:px-8 bg-slate-900 rounded-xl">
        <div className="lg:grid lg:grid-cols-2 lg:gap-8 lg:items-center">
          <div>
            <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
            Team at Auction Bazaar
            </h2>
            <p className="mt-3 pr-4 max-w-3xl text-lg text-gray-500">
            We have a diversified and strong team in Banking and the Technical Industry to serve you better.

            </p>
          </div>
          <div className="mt-8 lg:mt-0">
            <img src="/teams.png" />
          </div>
        </div>
      </div>
    </SectionContainerBase>
  );
}
